/* eslint-disable */
import $ from 'wee-dom';
import infoboxTemplate from '../components/locations-page/infobox-template';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.expanding-blocks').forEach(expandingBlocks => {
        // ---- Mobile Dropdown ----
        const menuToggle = expandingBlocks.querySelector('.expanding-blocks__menu-toggle');
        const navigation = expandingBlocks.querySelector('.expanding-blocks__navigation');
        const currentSelection = menuToggle?.querySelector('.expanding-blocks__menu-current');

        if (menuToggle && navigation) {
            menuToggle.addEventListener('click', function () {
                const isOpen = navigation.classList.toggle('is-open');
                this.setAttribute('aria-expanded', isOpen);
            });
        }

        expandingBlocks.querySelectorAll('[data-nav-target]').forEach(button => {
            button.addEventListener('click', function () {
                const targetId = this.dataset.navTarget;
                const activeIcon = this.querySelector('.expandable-button__icon');
                const title = this.querySelector('.expandable-button__title');
                const activeDetail = expandingBlocks.querySelector(`#${targetId}`);
                const mapElement = activeDetail?.querySelector('.content-locations-map__map');

                expandingBlocks.querySelectorAll('.expandable-details').forEach(detail => {
                        detail.hidden = detail.id !== targetId;
                    });

                expandingBlocks.querySelectorAll('[data-nav-target]').forEach(button => {
                        button.classList.remove('active');
                        const icon = button.querySelector('.expandable-button__icon');

                        if (icon) {
                            icon.textContent = '→';
                        }
                    });

                this.classList.add('active');

                if (activeIcon) {
                    activeIcon.textContent = '×';
                }

                if (title && currentSelection) {
                    currentSelection.textContent = title.textContent.trim();
                }

                if (navigation && menuToggle) {
                    navigation.classList.remove('is-open');
                    menuToggle.setAttribute('aria-expanded', 'false');
                }

                if (mapElement && typeof window.initLocationsMap === 'function') {
                    window.initLocationsMap(mapElement);
                }
            });
        });
        // ---- Mobile Dropdown end ----

        expandingBlocks.querySelectorAll('[data-nav-target]').forEach(button => {
            button.addEventListener('click', function () {
                const targetId = this.dataset.navTarget;
                const activeIcon = this.querySelector('.expandable-button__icon');
                const activeDetail = expandingBlocks.querySelector(`#${targetId}`);
                const mapElement = activeDetail?.querySelector('.content-locations-map__map');

                expandingBlocks.querySelectorAll('.expandable-details').forEach(detail => {
                        detail.hidden = detail.id !== targetId;
                    });

                expandingBlocks.querySelectorAll('[data-nav-target]').forEach(button => {
                        button.classList.remove('active');
                        const icon = button.querySelector('.expandable-button__icon');

                        if (icon) {
                            icon.textContent = '→';
                        }
                    });

                this.classList.add('active');

                if (activeIcon) {
                    activeIcon.textContent = '×';
                }

                if (mapElement && typeof window.initLocationsMap === 'function') {
                    window.initLocationsMap(mapElement);
                }
            });
        });
    });
});


/*
 * Google Maps callback
 *
 * Google calls this function after the Maps API has loaded.
 * It needs to be available on window because the API is loaded
 * from the Twig template with callback=googleMapsLoaded.
 */
window.googleMapsLoaded = function () {
    document.querySelectorAll('.expanding-blocks').forEach(expandingBlocks => {
        const activeDetail = expandingBlocks.querySelector('.expandable-details:not([hidden])');
        const mapElement = activeDetail.querySelector('.content-locations-map__map');
        
        if (!activeDetail) {
            return;
        }

        if (mapElement) {
            window.initLocationsMap(mapElement);
        }
    });

    document.querySelectorAll('.content-locations-wide-map').forEach(mapBlock => {
        const mapElement = mapBlock.querySelector('.content-locations-wide-map__map');
        if (mapElement) {
            window.initLocationsMap(mapElement);
        }
    });
};

window.initLocationsMap = function (mapElement) {
    if (!mapElement || !window.google?.maps) {
        return;
    }

    const locationsMapData = JSON.parse(
        mapElement.dataset.locations
    );

    if (!locationsMapData.length) {
        return;
    }

    const map = new google.maps.Map(mapElement, {
        zoom: 10,
        center: {
            lat: parseFloat(locationsMapData[0].lat),
            lng: parseFloat(locationsMapData[0].lng)
        },
        mapId: '36e19538f48b7ad681f8d08c',
        mapTypeControl: false,
        streetViewControl: false
    });

    const bounds = new google.maps.LatLngBounds();
    let activeInfoWindow = null;
    const showInfoWindows = mapElement.dataset.infoWindows === 'true';

    locationsMapData.forEach(location => {
        const position = {
            lat: parseFloat(location.lat),
            lng: parseFloat(location.lng)
        };

        const marker = new google.maps.marker.AdvancedMarkerElement({
            position: position,
            map: map,
            title: location.title
        });

        if (showInfoWindows) {
            const infoWindow = new google.maps.InfoWindow({
                content: infoboxTemplate({
                    title: location.title,
                    url: location.url,
                    address: location.address,
                    phone: $(location.phone),
                    directions: `https://www.google.com/maps/search/?api=1&query=${location.lat},${location.lng}`
                }),
            });

            marker.addListener('gmp-click', () => {
                if (activeInfoWindow) {
                    activeInfoWindow.close();
                }

                infoWindow.open(map, marker);
                activeInfoWindow = infoWindow;
            });
        }

        bounds.extend(position);
    });

    if (locationsMapData.length > 1) {
        map.fitBounds(bounds);
    }
};